import {useDispatch, useSelector} from "react-redux";
import {FIELD_LIST_INPUT_REDEEM_PRODUCT} from "../../utils/input-field-list-static-page";
import React, {useEffect} from "react";
import {
    setWaste4ChangeErrorMessage,
    setWaste4ChangeRedeemProductDetail
} from "../../reducers/waste-4-change.reducer";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../reducers/tools.reducer";
import {convertErrorMessage} from "../../utils/general-variable";
import FormGeneralComponent from "../../components/static-page/form-general.component";

const RedeemProduct = () => {
    const dispatch = useDispatch()
    const {redeemProductDetail, waste4ChangeErrorMessage} = useSelector(state => state.waste4ChangeReducer)
    const {fetching: getRedeem} = useFetch(API.W4C_GET_REDEEM)
    const {fetching: updateRedeem, isLoading} = useFetch(API.W4C_UPDATE_REDEEM)
    let fieldListInput = FIELD_LIST_INPUT_REDEEM_PRODUCT
    let showRedeemProduct = {
        label: 'Redeem Product',
        key: 'show_redeem_product',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setWaste4ChangeRedeemProductDetail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        updateRedeem(redeemProductDetail).then(response => {
            dispatch(setWaste4ChangeErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Redeem Updated'))
            dispatch(setWaste4ChangeRedeemProductDetail(response?.data))
        }).catch(err => {
            dispatch(setWaste4ChangeErrorMessage(convertErrorMessage(err)))
        })
    }

    useEffect(() => {
        getRedeem().then(response => {
            dispatch(setWaste4ChangeRedeemProductDetail(response?.data))
        })

        return () => {
            dispatch(setWaste4ChangeErrorMessage({}))
        }
    }, [])

    return (
        <FormGeneralComponent
            data={redeemProductDetail}
            switchToggleField={showRedeemProduct}
            fieldList={fieldListInput}
            onChange={onChange}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'grid grid-cols-2 gap-x-16 gap-y-4'}
            itemInputClassName={{
                key: 'description',
                value: ['col-span-2', '']
            }}
            errorMessage={waste4ChangeErrorMessage}
            isLoading={isLoading}
        />
    )
}

export default RedeemProduct